"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'type-warranty-field',
    props: {
        changeWarranty: { type: Boolean }
    },
    emits: ["change"],
    setup(__props, { emit }) {
        const props = __props;
        const input = (0, vue_2.ref)(null);
        (0, vue_2.watch)(() => props.changeWarranty, () => {
            input.value = null;
        });
        (0, vue_2.watch)(input, () => {
            emit("change", Number(input.value));
        });
        return { __sfc: true, emit, input, props };
    }
});
